var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"gap":"16px"}},[_c('us-bank-failures'),_c('list-of-us-bank-failures')],1)}
var staticRenderFns = []

export { render, staticRenderFns }